<div id="panel-2" role="tabpanel" aria-labelledby="tab-2" hidden class="use-case-wrapper">
    <app-card
            [tabindex]="2"
            [cardPadding]="'32'"
            [cardMainTitle]="'ONBOARDING.CONSENT_USE_CASE.CUSTOM_USE_CASE' | translate"
            [ariaLabel]="('ONBOARDING.CONSENT_USE_CASE.CUSTOM_USE_CASE' | translate) + ('GENERAL.USE_CASE' | translate)"
            (cardClickEvent)="myUseCaseEvent.emit()">
    </app-card>
</div>
